import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { BatchListView } from 'src/sections/cheque-factoring/view';

export default function FactoringBatchListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Factoring Batches</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_FACTORING_BATCH,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <BatchListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
